import { render, staticRenderFns } from "./ConferenciaEdit.vue?vue&type=template&id=b4ffaa7a"
import script from "./ConferenciaEdit.vue?vue&type=script&lang=js"
export * from "./ConferenciaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports